// extracted by mini-css-extract-plugin
export default {"IconContainer":"webpack-components-core-Banner-components-BannerIcon-module__IconContainer"};